export enum CATEGORY_PERMISSIONS {
  CATEGORY_VIEW = 'PRODUCT_CATEGORYVIEW',
  CATEGORY_WRITE = 'PRODUCT_CATEGORYWRITE',
}
